import * as yup from 'yup';
import { mapYupObjectError, objectMap } from 'utils/helpers';
import { requiredOnly, validateAmount, validatePhone } from 'utils/validation';
import { IFormValues } from './MobileMoneyTransfer.model';

const schema = yup.object().shape({
  networkCode: requiredOnly('Network'),
  sourceAccount: requiredOnly('Source Account'),
  phoneNumber: validatePhone('Beneficiary Wallet Number'),
  narration: requiredOnly('Narration'),
  amount: validateAmount(),
  eLevyCharge: requiredOnly('eLevy Fee'),
});

const validate = (values: IFormValues) => {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (e) {
    const valErrs = mapYupObjectError<IFormValues>(e);
    return objectMap(valErrs, (v) => v[0]);
  }
  return undefined;
};

export default validate;
